import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { getCollaborationLoading: true, data: '', error: false };

export function collaborationDataReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_LnD_DATA:
            return {
                getCollaborationLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_LnD_DATA:
            return {
                getCollaborationLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERROR_LnD_DATA:
            return {
                getCollaborationLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/collaboration.reducer.js